<template>
  <div class="main">
    <!-- title -->
    <div class="subTitle">
      <el-link
        icon="el-icon-arrow-left"
        :underline="false"
        href="#/pushNotification"
        >Notification Management</el-link
      >
    </div>
    <h3 class="title" content="edit" placement="bottom">Create Notification</h3>
    <div class="detailContent">
      <div class="requireRmarks">*Required Fields</div>
      <el-form
        label-width="50%"
        label-position="left"
        ref="formNotification"
        :model="formNotification"
        :rules="formNotificationRules"
        class="formNotification"
      >
        <el-row>
          <h4>Notification Type</h4>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item label="Notification Type" prop="notificationType">
              <el-select
                v-model="formNotification.notificationType"
                :popper-append-to-body="false"
                @change="handleTypeChange"
              >
                <el-option label="System Updates" value="SYSTEM"></el-option>
                <el-option
                  label="Investment Updates"
                  value="INVESTMENT"
                ></el-option>
                <el-option
                  label="Corporate Updates"
                  value="CORPORATE"
                ></el-option>
                <el-option label="Market Updates" value="MARKET"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="Notification category"
              prop="notificationCategory"
            >
              <el-input
                v-model="formNotification.notificationCategory"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item label="Important" prop="important">
              <el-switch v-model="formNotification.important"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-row>
          <h4>Client Segmentation</h4>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item label="Sales office" prop="salesOffice">
              <el-select
                multiple
                v-model="formNotification.salesOffice"
                :popper-append-to-body="false"
                @change="changeSalesOffice"
                :disabled="$store.state.userLevel >= 2"
              >
                <el-option
                  v-for="(item, index) in salesOfficeList"
                  :key="index"
                  :label="item.name"
                  :value="item.code"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row
          :gutter="50"
          v-if="formNotification.notificationType == 'SYSTEM'"
        >
          <el-col :span="24">
            <el-form-item label="Region" prop="region" label-width="24%">
              <el-checkbox-group
                v-model="formNotification.region"
                :disabled="formNotification.notificationType != 'SYSTEM'"
              >
                <el-checkbox
                  :label="item.code"
                  v-for="(item, index) in regionList"
                  :key="index"
                  >{{ item.name }}</el-checkbox
                >
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row
          :gutter="50"
          v-if="formNotification.notificationType != 'SYSTEM'"
        >
          <el-col :span="12">
            <el-form-item
              label="Client / Partner list (CSV file)"
              prop="csvFile"
            >
              <el-row type="flex" justify="space-bwteen">
                <el-radio
                  v-model="formNotification.csvType"
                  :label="CSV_FILE_TYPE.ID_ONLY"
                  >CSV file with Client ID & Partner ID</el-radio
                >
                <el-radio
                  v-model="formNotification.csvType"
                  :label="CSV_FILE_TYPE.CLIENT_PARAM"
                  >CSV file with personalized values (Client ID only)</el-radio
                >
                <el-radio
                  v-model="formNotification.csvType"
                  :label="CSV_FILE_TYPE.PARTNER_PARAM"
                  >CSV file with personalized values (Partner ID only)</el-radio
                >
              </el-row>
              <upload-image
                ref="UploadCSV"
                :fileParams="CSVFileParams"
                :fileList="CSVFileList"
                @getSuccessRes="getCSVRes"
                :limit="1"
              ></upload-image>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-link
              icon="el-icon-download"
              :underline="false"
              style="margin-top: 50px"
              @click="handleDownloadTemplate"
              >Download Template</el-link
            >
          </el-col>
        </el-row>
        <el-row
          :gutter="50"
          v-if="formNotification.notificationType != 'SYSTEM'"
        >
          <el-col :span="12">
            <el-form-item>
              <el-button
                style="width: 100%"
                @click="handleView"
                :disabled="!formNotification.csvFile"
                >View client list</el-button
              >
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider></el-divider>

        <el-row>
          <h4>Title</h4>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item label="Title (EN)" prop="titleEn">
              <el-input
                v-model="formNotification.titleEn"
                placeholder="Please enter"
                maxlength="200"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Title (JP)" prop="titleJp">
              <el-input
                v-model="formNotification.titleJp"
                placeholder="Please enter"
                maxlength="200"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item label="Title (TC)" prop="titleTc">
              <el-input
                v-model="formNotification.titleTc"
                placeholder="Please enter"
                maxlength="200"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Title (SC)" prop="titleSc">
              <el-input
                v-model="formNotification.titleSc"
                placeholder="Please enter"
                maxlength="200"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider></el-divider>

        <el-row>
          <h4>Notification Summary</h4>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item label="Summary (EN)" prop="summaryEn">
              <el-input
                v-model="formNotification.summaryEn"
                placeholder="Please enter"
                maxlength="70"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Summary (JP)" prop="summaryJp">
              <el-input
                v-model="formNotification.summaryJp"
                placeholder="Please enter"
                maxlength="70"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item label="Summary (TC)" prop="summaryTc">
              <el-input
                v-model="formNotification.summaryTc"
                placeholder="Please enter"
                maxlength="70"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Summary (SC)" prop="summarySc">
              <el-input
                v-model="formNotification.summarySc"
                placeholder="Please enter"
                maxlength="70"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider></el-divider>

        <el-row type="flex" justify="space-between" align="center">
          <h4>Content</h4>
          <el-link
            v-if="csvHasVariables"
            icon="el-icon-warning-outline"
            :underline="false"
            style="margin-bottom: 30px"
            @click="tagDialog = true"
            >How to use tags?</el-link
          >
        </el-row>
        <el-row :gutter="50">
          <el-col :span="24">
            <el-form-item
              label="Content (EN)"
              prop="contentEn"
              label-width="24%"
            >
              <quill-editor
                v-model="formNotification.contentEn"
                class="ql-editor"
                id="quillEn"
                @blur="validContent('contentEn', 'quillEn')"
                @change="validContent('contentEn')"
              ></quill-editor>
              <div style="text-align: right; font-size: 12px; color: #909399;">{{ $commonjs.stripHtml(formNotification.contentEn).length }} / 3500</div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="24">
            <el-form-item
              label="Content (JP)"
              prop="contentJp"
              label-width="24%"
            >
              <quill-editor
                v-model="formNotification.contentJp"
                class="ql-editor"
                id="quillJp"
                @blur="validContent('contentJp', 'quillJp')"
                @change="validContent('contentJp')"
              ></quill-editor>
              <div style="text-align: right; font-size: 12px; color: #909399;">{{ $commonjs.stripHtml(formNotification.contentJp).length }} / 3500</div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="24">
            <el-form-item
              label="Content (TC)"
              prop="contentTc"
              label-width="24%"
            >
              <quill-editor
                v-model="formNotification.contentTc"
                class="ql-editor"
                id="quillTc"
                @blur="validContent('contentTc', 'quillTc')"
                @change="validContent('contentTc')"
              ></quill-editor>
              <div style="text-align: right; font-size: 12px; color: #909399;">{{ $commonjs.stripHtml(formNotification.contentTc).length }} / 3500</div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="24">
            <el-form-item
              label="Content (SC)"
              prop="contentSc"
              label-width="24%"
            >
              <quill-editor
                v-model="formNotification.contentSc"
                class="ql-editor"
                id="quillSc"
                @blur="validContent('contentSc', 'quillSc')"
                @change="validContent('contentSc')"
              ></quill-editor>
              <div style="text-align: right; font-size: 12px; color: #909399;">{{ $commonjs.stripHtml(formNotification.contentSc).length }} / 3500</div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-row>
          <h4 style="margin-bottom: 8px">Images</h4>
          <p style="font-size: 14px; color: #4f7a96">
            Suggeset size: 1125(W) x 630(H)
          </p>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item
              label="1 image for all languages"
              prop="imageIsSame4All"
            >
              <el-switch v-model="formNotification.imageIsSame4All"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item label="- English" prop="imageEn">
              <upload-image
                ref="UploadImageEn"
                :fileParams="imageEnFileParams"
                :fileList="imageEnFileList"
                @getSuccessRes="getImageEnRes"
                :limit="1"
                :accept="'image'"
              ></upload-image>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="- Japanese" prop="imageJp">
              <upload-image
                ref="UploadImageJp"
                :fileParams="imageJpFileParams"
                :fileList="imageJpFileList"
                @getSuccessRes="getImageJpRes"
                :limit="1"
                :accept="'image'"
                :disabled="formNotification.imageIsSame4All"
              ></upload-image>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item label="- Traditional Chinese" prop="imageTc">
              <upload-image
                ref="UploadImageTc"
                :fileParams="imageTcFileParams"
                :fileList="imageTcFileList"
                @getSuccessRes="getImageTcRes"
                :limit="1"
                :accept="'image'"
                :disabled="formNotification.imageIsSame4All"
              ></upload-image>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="- Simplified Chinese" prop="imageSc">
              <upload-image
                ref="UploadImageSc"
                :fileParams="imageScFileParams"
                :fileList="imageScFileList"
                @getSuccessRes="getImageScRes"
                :limit="1"
                :accept="'image'"
                :disabled="formNotification.imageIsSame4All"
              ></upload-image>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <div v-if="formNotification.notificationType != 'SYSTEM'">
          <el-row>
            <h4>Button1</h4>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item label="Button Type" prop="button1Type">
                <el-select
                  v-model="formNotification.button1Type"
                  placeholder="Please select"
                  @change="(v) => handleButtonChecking(v, '1')"
                >
                  <el-option label="None" value="NONE"></el-option>
                  <el-option label="Go to URL" value="URL"></el-option>
                  <el-option
                    label="Go to Project page"
                    value="PROJECT"
                  ></el-option>
                  <el-option
                    label="Go to Investment page"
                    value="INVESTMENT"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12" v-if="formNotification.button1Type == 'PROJECT'">
              <el-form-item
                label="Project ID & Name (HK)"
                prop="button1IdNameHK"
                :rules="{
                  required:
                    formNotification.button1Type == 'PROJECT' &&
                    formNotification.salesOffice.indexOf('HK') !== -1
                      ? true
                      : false,
                  message: 'Project ID & Name cannot be empty',
                }"
              >
                <el-select
                  filterable
                  v-model="formNotification.button1IdNameHK"
                  placeholder="Please select"
                  :disabled="
                    formNotification.button1Type !== 'PROJECT' ||
                    formNotification.salesOffice.indexOf('HK') == -1
                  "
                >
                  <el-option
                    v-for="(item, index) in projectListHK"
                    :label="
                      item.name.EN
                        ? item.name.EN + ' - (' + item.region + ')'
                        : item.name.JA
                        ? item.name.JA + ' - (' + item.region + ')'
                        : item.name.ZH_HK
                        ? item.name.ZH_HK + ' - (' + item.region + ')'
                        : item.name.ZH_CN + ' - (' + item.region + ')'
                    "
                    :value="item.id"
                    :key="index"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="formNotification.button1Type == 'PROJECT'">
              <el-form-item
                label="Project ID & Name (SG)"
                prop="button1IdNameSG"
                :rules="{
                  required:
                    formNotification.button1Type == 'PROJECT' &&
                    formNotification.salesOffice.indexOf('SG') !== -1
                      ? true
                      : false,
                  message: 'Project ID & Name cannot be empty',
                }"
              >
                <el-select
                  filterable
                  v-model="formNotification.button1IdNameSG"
                  placeholder="Please select"
                  :disabled="
                    formNotification.button1Type !== 'PROJECT' ||
                    formNotification.salesOffice.indexOf('SG') == -1
                  "
                >
                  <el-option
                    v-for="(item, index) in projectListSG"
                    :label="
                      item.name.EN
                        ? item.name.EN + ' - (' + item.region + ')'
                        : item.name.JA
                        ? item.name.JA + ' - (' + item.region + ')'
                        : item.name.ZH_HK
                        ? item.name.ZH_HK + ' - (' + item.region + ')'
                        : item.name.ZH_CN + ' - (' + item.region + ')'
                    "
                    :value="item.id"
                    :key="index"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50" v-if="formNotification.button1Type != 'NONE'">
            <el-col :span="12">
              <el-form-item
                label="Button Name (EN)"
                prop="button1NameEn"
                :rules="{
                  required:
                    formNotification.button1Type == 'NONE' ? false : true,
                  message: 'Button Name (EN) cannot be empty',
                }"
              >
                <el-input
                  maxlength="15"
                  placeholder="Please enter"
                  v-model="formNotification.button1NameEn"
                  :disabled="formNotification.button1Type == 'NONE'"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="Button Name (JP)"
                prop="button1NameJp"
                :rules="{
                  required:
                    formNotification.button1Type == 'NONE' ? false : true,
                  message: 'Button Name (JP) cannot be empty',
                }"
              >
                <el-input
                  maxlength="15"
                  placeholder="Please enter"
                  v-model="formNotification.button1NameJp"
                  :disabled="formNotification.button1Type == 'NONE'"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50" v-if="formNotification.button1Type != 'NONE'">
            <el-col :span="12">
              <el-form-item
                label="Button Name (TC)"
                prop="button1NameTc"
                :rules="{
                  required:
                    formNotification.button1Type == 'NONE' ? false : true,
                  message: 'Button Name (TC) cannot be empty',
                }"
              >
                <el-input
                  maxlength="15"
                  placeholder="Please enter"
                  v-model="formNotification.button1NameTc"
                  :disabled="formNotification.button1Type == 'NONE'"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="Button Name (SC)"
                prop="button1NameSc"
                :rules="{
                  required:
                    formNotification.button1Type == 'NONE' ? false : true,
                  message: 'Button Name (SC) cannot be empty',
                }"
              >
                <el-input
                  maxlength="15"
                  placeholder="Please enter"
                  v-model="formNotification.button1NameSc"
                  :disabled="formNotification.button1Type == 'NONE'"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50" v-if="formNotification.button1Type == 'URL'">
            <el-col :span="12">
              <el-form-item
                label="URL (EN)"
                prop="button1URLEn"
                :rules="{
                  required:
                    formNotification.button1Type == 'URL' ? true : false,
                  message: 'URL (EN) cannot be empty',
                }"
              >
                <el-input
                  placeholder="Please enter"
                  v-model="formNotification.button1URLEn"
                  :disabled="formNotification.button1Type !== 'URL'"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="URL (JP)"
                prop="button1URLJp"
                :rules="{
                  required:
                    formNotification.button1Type == 'URL' ? true : false,
                  message: 'URL (JP) cannot be empty',
                }"
              >
                <el-input
                  placeholder="Please enter"
                  v-model="formNotification.button1URLJp"
                  :disabled="formNotification.button1Type !== 'URL'"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50" v-if="formNotification.button1Type == 'URL'">
            <el-col :span="12">
              <el-form-item
                label="URL (TC)"
                prop="button1URLTc"
                :rules="{
                  required:
                    formNotification.button1Type == 'URL' ? true : false,
                  message: 'URL (TC) cannot be empty',
                }"
              >
                <el-input
                  placeholder="Please enter"
                  v-model="formNotification.button1URLTc"
                  :disabled="formNotification.button1Type !== 'URL'"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="URL (SC)"
                prop="button1URLSc"
                :rules="{
                  required:
                    formNotification.button1Type == 'URL' ? true : false,
                  message: 'URL (SC) cannot be empty',
                }"
              >
                <el-input
                  placeholder="Please enter"
                  v-model="formNotification.button1URLSc"
                  :disabled="formNotification.button1Type !== 'URL'"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-divider></el-divider>
          <el-row>
            <h4>Button2</h4>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item label="Button Type" prop="button2Type">
                <el-select
                  :disabled="formNotification.button1Type == 'NONE'"
                  v-model="formNotification.button2Type"
                  placeholder="Please select"
                  @change="(v) => handleButtonChecking(v, '2')"
                >
                  <el-option label="None" value="NONE"></el-option>
                  <el-option label="Go to URL" value="URL"></el-option>
                  <el-option
                    label="Go to Project page"
                    value="PROJECT"
                  ></el-option>
                  <el-option
                    label="Go to Investment page"
                    value="INVESTMENT"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12" v-if="formNotification.button2Type == 'PROJECT'">
              <el-form-item
                label="Project ID & Name (HK)"
                prop="button2IdNameHK"
                :rules="{
                  required:
                    formNotification.button2Type == 'PROJECT' &&
                    formNotification.salesOffice.indexOf('HK') !== -1
                      ? true
                      : false,
                  message: 'Project ID & Name cannot be empty',
                }"
              >
                <el-select
                  filterable
                  v-model="formNotification.button2IdNameHK"
                  placeholder="Please select"
                  :disabled="
                    formNotification.button2Type !== 'PROJECT' ||
                    formNotification.salesOffice.indexOf('HK') == -1
                  "
                >
                  <el-option
                    v-for="(item, index) in projectListHK"
                    :label="
                      item.name.EN
                        ? item.name.EN + ' - (' + item.region + ')'
                        : item.name.JA
                        ? item.name.JA + ' - (' + item.region + ')'
                        : item.name.ZH_HK
                        ? item.name.ZH_HK + ' - (' + item.region + ')'
                        : item.name.ZH_CN + ' - (' + item.region + ')'
                    "
                    :value="item.id"
                    :key="index"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="formNotification.button2Type == 'PROJECT'">
              <el-form-item
                label="Project ID & Name (SG)"
                prop="button2IdNameSG"
                :rules="{
                  required:
                    formNotification.button2Type == 'PROJECT' &&
                    formNotification.salesOffice.indexOf('SG') !== -1
                      ? true
                      : false,
                  message: 'Project ID & Name cannot be empty',
                }"
              >
                <el-select
                  filterable
                  v-model="formNotification.button2IdNameSG"
                  placeholder="Please select"
                  :disabled="
                    formNotification.button2Type !== 'PROJECT' ||
                    formNotification.salesOffice.indexOf('SG') == -1
                  "
                >
                  <el-option
                    v-for="(item, index) in projectListSG"
                    :label="
                      item.name.EN
                        ? item.name.EN + ' - (' + item.region + ')'
                        : item.name.JA
                        ? item.name.JA + ' - (' + item.region + ')'
                        : item.name.ZH_HK
                        ? item.name.ZH_HK + ' - (' + item.region + ')'
                        : item.name.ZH_CN + ' - (' + item.region + ')'
                    "
                    :value="item.id"
                    :key="index"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50" v-if="formNotification.button2Type != 'NONE'">
            <el-col :span="12">
              <el-form-item
                label="Button Name (EN)"
                prop="button2NameEn"
                :rules="{
                  required:
                    formNotification.button2Type == 'NONE' ? false : true,
                  message: 'Button Name (EN) cannot be empty',
                }"
              >
                <el-input
                  maxlength="15"
                  placeholder="Please enter"
                  v-model="formNotification.button2NameEn"
                  :disabled="formNotification.button2Type == 'NONE'"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="Button Name (JP)"
                prop="button2NameJp"
                :rules="{
                  required:
                    formNotification.button2Type == 'NONE' ? false : true,
                  message: 'Button Name (JP) cannot be empty',
                }"
              >
                <el-input
                  maxlength="15"
                  placeholder="Please enter"
                  v-model="formNotification.button2NameJp"
                  :disabled="formNotification.button2Type == 'NONE'"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50" v-if="formNotification.button2Type != 'NONE'">
            <el-col :span="12">
              <el-form-item
                label="Button Name (TC)"
                prop="button2NameTc"
                :rules="{
                  required:
                    formNotification.button2Type == 'NONE' ? false : true,
                  message: 'Button Name (TC) cannot be empty',
                }"
              >
                <el-input
                  maxlength="15"
                  placeholder="Please enter"
                  v-model="formNotification.button2NameTc"
                  :disabled="formNotification.button2Type == 'NONE'"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="Button Name (SC)"
                prop="button2NameSc"
                :rules="{
                  required:
                    formNotification.button2Type == 'NONE' ? false : true,
                  message: 'Button Name (SC) cannot be empty',
                }"
              >
                <el-input
                  maxlength="15"
                  placeholder="Please enter"
                  v-model="formNotification.button2NameSc"
                  :disabled="formNotification.button2Type == 'NONE'"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50" v-if="formNotification.button2Type == 'URL'">
            <el-col :span="12">
              <el-form-item
                label="URL (EN)"
                prop="button2URLEn"
                :rules="{
                  required:
                    formNotification.button2Type == 'URL' ? true : false,
                  message: 'URL (EN) cannot be empty',
                }"
              >
                <el-input
                  placeholder="Please enter"
                  v-model="formNotification.button2URLEn"
                  :disabled="formNotification.button2Type !== 'URL'"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="URL (JP)"
                prop="button2URLJp"
                :rules="{
                  required:
                    formNotification.button2Type == 'URL' ? true : false,
                  message: 'URL (JP) cannot be empty',
                }"
              >
                <el-input
                  placeholder="Please enter"
                  v-model="formNotification.button2URLJp"
                  :disabled="formNotification.button2Type !== 'URL'"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50" v-if="formNotification.button2Type == 'URL'">
            <el-col :span="12">
              <el-form-item
                label="URL (TC)"
                prop="button2URLTc"
                :rules="{
                  required:
                    formNotification.button2Type == 'URL' ? true : false,
                  message: 'URL (TC) cannot be empty',
                }"
              >
                <el-input
                  placeholder="Please enter"
                  v-model="formNotification.button2URLTc"
                  :disabled="formNotification.button2Type !== 'URL'"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="URL (SC)"
                prop="button2URLSc"
                :rules="{
                  required:
                    formNotification.button2Type == 'URL' ? true : false,
                  message: 'URL (SC) cannot be empty',
                }"
              >
                <el-input
                  placeholder="Please enter"
                  v-model="formNotification.button2URLSc"
                  :disabled="formNotification.button2Type !== 'URL'"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-divider></el-divider>
        </div>
        <el-row>
          <h4>Delivery & Status</h4>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item
              label="Delivery Date & Time (UTC+8)"
              prop="deliveryDate"
            >
              <el-row
                :gutter="10"
                justify="space-between"
                type="flex"
                style="margin-bottom: 0"
              >
                <el-col :span="12">
                  <el-form-item prop="deliveryD">
                    <el-date-picker
                      @change="handleDeliveryDate"
                      v-model="formNotification.deliveryD"
                      type="date"
                      range-separator="/"
                      format="yyyy/MM/dd"
                      value-format="yyyy/MM/dd"
                      style="width: 100%"
                      placeholder="Date"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item prop="deliveryT">
                    <el-time-select
                      @change="handleDeliveryDate"
                      v-model="formNotification.deliveryT"
                      :picker-options="{
                        start: '00:00',
                        step: '00:15',
                        end: '24:00',
                      }"
                      style="width: 100%"
                      placeholder="Time"
                    >
                    </el-time-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <el-row style="padding: 25px 0" type="flex" justify="end" :gutter="20">
      <el-col :span="4">
        <el-button v-if="showSave" class="reset" style="width: 100%" @click="handleCancel"
          >Cancel</el-button
        >
      </el-col>
      <el-col :span="4">
        <el-button
          v-if="showSave"
          type="primary"
          style="width: 100%"
          @click="handleCreate"
          >Create</el-button
        >
      </el-col>
    </el-row>
    <el-dialog
      title="Client / Partner List"
      :visible.sync="viewDialog"
      width="1300px"
    >
      <div class="clientListFilter">
        <div>
          <span>Total in CSV file:{{ clientTotal }}</span>
          <el-divider direction="vertical"></el-divider>
          <span>HK Sales office:{{ hkTotal }}</span>
          <el-divider direction="vertical"></el-divider>
          <span>SG Sales office:{{ sgTotal }}</span>
          <el-divider direction="vertical"></el-divider>
          <span>Ignored:{{ csvIgnoreTotal }}</span>
        </div>
        <el-button
          icon="el-icon-refresh"
          type="primary"
          @click="refreshClientList"
          >Refresh Data</el-button
        >
      </div>
      <el-form
        label-position="top"
        ref="formFilter"
        :model="formFilter"
        :inline="true"
        style="text-align: left"
        class="demo-form-inline"
      >
        <el-form-item prop="clientId">
          <el-input
            v-model="formFilter.clientId"
            placeholder="Client / Partner ID"
            style="width: 150px"
          ></el-input>
        </el-form-item>
        <el-form-item prop="salesOffice">
          <el-select
            v-model="formFilter.salesOffice"
            placeholder="Sales Office"
            style="width: 120px"
          >
            <el-option
              v-for="(item, index) in salesOfficeList"
              :key="index"
              :value="item.code"
              :label="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="region">
          <el-select
            v-model="formFilter.region"
            placeholder="Region"
            style="width: 120px"
          >
            <el-option
              v-for="(item, index) in regionList"
              :key="index"
              :value="item.code"
              :label="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="userStatus">
          <el-select
            v-model="formFilter.userStatus"
            placeholder="User Status"
            style="width: 120px"
          >
            <el-option value="OPENED" label="Inactive"></el-option>
            <el-option value="ACTIVATED" label="Active"></el-option>
            <el-option value="SUSPENDED" label="Suspended"></el-option>
            <el-option value="DELETED" label="Deleted"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="inboxStatus">
          <el-select
            v-model="formFilter.inboxStatus"
            placeholder="Inbox Status"
            style="width: 130px"
          >
            <el-option value="RECEIVED" label="Received"></el-option>
            <el-option value="PENDING" label="Pending"></el-option>
            <el-option value="IGNORED" label="Ignored"></el-option>
            <el-option value="FAILED" label="Failed"></el-option>
            <el-option value="DELETED" label="Deleted"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="pushStatus">
          <el-select
            v-model="formFilter.pushStatus"
            placeholder="Push Status"
            style="width: 120px"
          >
            <el-option value="RECEIVED" label="Received"></el-option>
            <el-option value="PENDING" label="Pending"></el-option>
            <el-option value="IGNORED" label="Ignored"></el-option>
            <el-option value="FAILED" label="Failed"></el-option>
            <el-option value="DELETED" label="Deleted"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button class="search" @click="submitApply">Apply</el-button>
        </el-form-item>
        <el-form-item>
          <el-button class="reset" @click="resetForm('formFilter')"
            >Reset</el-button
          >
        </el-form-item>
      </el-form>
      <el-table :data="tableData" max-height="500px">
        <el-table-column prop="sfUserType" label="User Type" width="100">
          <template slot-scope="scope">{{
            $commonjs.sfUserIdTypeMap(scope.row.sfUserType)
          }}</template>
        </el-table-column>
        <el-table-column label="Record Type">
          <template slot-scope="scope">{{
            scope.row.salesforceRecordType.hasOwnProperty("name")
              ? scope.row.salesforceRecordType.name
              : "-"
          }}</template>
        </el-table-column>
        <el-table-column
          prop="clientId"
          label="ID"
          width="70"
        ></el-table-column>
        <el-table-column prop="username" label="User Name"></el-table-column>
        <el-table-column label="SF Full Name">
          <template slot-scope="scope">{{
            $commonjs.formatDisplayName(scope.row, "-")
          }}</template>
        </el-table-column>
        <el-table-column prop="email" label="Email">
          <template slot-scope="scope">{{
            scope.row.email ? scope.row.email : "-"
          }}</template>
        </el-table-column>
        <el-table-column prop="salesOffice" label="Sales office">
          <template slot-scope="scope">{{
            $commonjs.salesOfficeMap(scope.row.salesOffice)
          }}</template>
        </el-table-column>
        <el-table-column prop="region" label="Region">
          <template slot-scope="scope">{{
            $commonjs.regionMap(scope.row.region)
          }}</template>
        </el-table-column>
        <el-table-column prop="userStatus" label="User Status">
          <template slot-scope="scope">{{
            $commonjs.userStatusMap(scope.row.userStatus)
          }}</template>
        </el-table-column>
        <el-table-column prop="inboxStatus" label="Inbox Status">
          <template slot-scope="scope">{{
            $commonjs.inboxStatusMap(scope.row.inboxStatus)
          }}</template>
        </el-table-column>
        <el-table-column prop="pushStatus" label="Push Status">
          <template slot-scope="scope">{{
            $commonjs.inboxStatusMap(scope.row.pushStatus)
          }}</template>
        </el-table-column>
      </el-table>
      <app-pagination
        @size-change="
          (v) => {
            currentSize = v;
            currentPage = 1;
            getClientList();
          }
        "
        @current-change="
          (v) => {
            currentPage = v;
            getClientList();
          }
        "
        :current-page="currentPage"
        :page-sizes="[5, 10, 20, 50]"
        :total="total"
        :page-size="currentSize"
      ></app-pagination>
    </el-dialog>
    <!-- tag -->
    <el-dialog
      :visible.sync="tagDialog"
      width="500px"
      :close-on-click-modal="false"
    >
      <p slot="title" style="color: #003448; font-weight: 600; font-size: 20px">
        How to use tags?
      </p>
      <div style="text-align: left; font-size: 16px; color: #003448">
        <p style="margin-bottom: 15px">
          Insert the tag into the sentence. For example:
        </p>
        <p style="line-height: 22px">The value of &lt;AMT1&gt; is 1000</p>
        <p style="line-height: 22px">The value of &lt;AMT2&gt; is 2000</p>
        <p style="line-height: 22px">The value of &lt;AMT3&gt; is 3000</p>
        <p style="line-height: 22px">The value of &lt;AMT4&gt; is 4000</p>
        <strong style="display: block; margin: 10px 0">Type:</strong>
        <el-card
          class="box-card"
          shadow="always"
          :body-style="{
            fontSize: '14px',
            lineHeight: '20px',
            wordBreak: 'break-word',
            background: '#f5f7fa',
          }"
        >
          <p style="margin-bottom: 15px">
            Walton LAD Verano Breakdown (18/08/2020)
          </p>
          <p>
            $&lt;AMT1&gt; is remitted from Walton International Group Limited
            (Account Number:808 249XXX 274) to your designated account.
          </p>
          <p>Principal Repayment: $&lt;AMT2&gt;</p>
          <p style="margin-bottom: 15px">Interest: $&lt;AMT3&gt;</p>
          <p>Outstanding Balance: $&lt;AMT4&gt;</p>
        </el-card>
        <strong style="display: block; margin: 10px 0">Output:</strong>
        <el-card
          class="box-card"
          shadow="always"
          :body-style="{
            fontSize: '14px',
            lineHeight: '20px',
            wordBreak: 'break-word',
            background: '#f5f7fa',
          }"
        >
          <p style="margin-bottom: 15px">
            Walton LAD Verano Breakdown (18/08/2020)
          </p>
          <p>
            $1000 is remitted from Walton International Group Limited (Account
            Number:808 249XXX 274) to your designated account.
          </p>
          <p>Principal Repayment: $2000</p>
          <p style="margin-bottom: 15px">Interest: $3000</p>
          <p>Outstanding Balance: $4000</p>
        </el-card>
      </div>
    </el-dialog>
    <!-- csv -->
    <!-- <el-dialog
            title="CSV File Instruction"
            :visible.sync="csvDialog"
            width="550px"
            :close-on-click-modal="false"
        >
            <div style="text-align:left;font-size:16px;">
                <el-row type="flex" justify="space-between" align="middle">
                    <p>Template of Client ID with other values </p>
                    <el-button @click="handleDownloadTemplate">Download</el-button>
                </el-row>
                <strong style="margin-bottom:15px;display:block">Comparison Table</strong>
                <div style="max-height:380px;overflow:auto">
                    <p style="line-height:30px">&lt;AMT1&gt;:amount</p>
                    <p style="line-height:30px">&lt;AMT2&gt;:amount</p>
                    <p style="line-height:30px">&lt;AMT3&gt;:amount</p>
                    <p style="line-height:30px">&lt;AMT4&gt;:amount</p>
                    <p style="line-height:30px">&lt;AMT5&gt;:amount</p>
                    <p style="line-height:30px">&lt;AMT6&gt;:amount</p>
                    <p style="line-height:30px">&lt;AMT7&gt;:amount</p>
                    <p style="line-height:30px">&lt;TEXT1_EN&gt;:text</p>
                    <p style="line-height:30px">&lt;TEXT1_TC&gt;:text</p>
                    <p style="line-height:30px">&lt;TEXT1_SC&gt;:text</p>
                    <p style="line-height:30px">&lt;TEXT1_JP&gt;:text</p>
                    <p style="line-height:30px">&lt;TEXT2_EN&gt;:text</p>
                    <p style="line-height:30px">&lt;TEXT2_TC&gt;:text</p>
                    <p style="line-height:30px">&lt;TEXT2_SC&gt;:text</p>
                    <p style="line-height:30px">&lt;TEXT2_JP&gt;:text</p>
                    <p style="line-height:30px">&lt;TEXT3_EN&gt;:text</p>
                    <p style="line-height:30px">&lt;TEXT3_TC&gt;:text</p>
                    <p style="line-height:30px">&lt;TEXT3_SC&gt;:text</p>
                    <p style="line-height:30px">&lt;TEXT3_JP&gt;:text</p>
                    <p style="line-height:30px">&lt;TEXT4_EN&gt;:text</p>
                    <p style="line-height:30px">&lt;TEXT4_TC&gt;:text</p>
                    <p style="line-height:30px">&lt;TEXT4_SC&gt;:text</p>
                    <p style="line-height:30px">&lt;TEXT4_JP&gt;:text</p>
                    <p style="line-height:30px">&lt;TEXT5_EN&gt;:text</p>
                    <p style="line-height:30px">&lt;TEXT5_TC&gt;:text</p>
                    <p style="line-height:30px">&lt;TEXT5_SC&gt;:text</p>
                    <p style="line-height:30px">&lt;TEXT5_JP&gt;:text</p>
                    <p style="line-height:30px">&lt;TEXT6_EN&gt;:text</p>
                    <p style="line-height:30px">&lt;TEXT6_TC&gt;:text</p>
                    <p style="line-height:30px">&lt;TEXT6_SC&gt;:text</p>
                    <p style="line-height:30px">&lt;TEXT6_JP&gt;:text</p>
                    <p style="line-height:30px">&lt;TEXT7_EN&gt;:text</p>
                    <p style="line-height:30px">&lt;TEXT7_TC&gt;:text</p>
                    <p style="line-height:30px">&lt;TEXT7_SC&gt;:text</p>
                    <p style="line-height:30px">&lt;TEXT7_JP&gt;:text</p>
                </div>
            </div>
        </el-dialog> -->
  </div>
</template>

<script>
import {
  getSalesOffice,
  getSalesRegion,
  notificationAdd,
  projectList,
  notificationClientList,
  notificationClientListDelete,
} from "@/request/api";
import UploadImage from "@/components/common/upload/Image";
export default {
  name: "createNotification",
  data() {
    var regionValidator = (rule, value, callback) => {
      if (this.formNotification.salesOffice.length > 1) {
        if (
          value.indexOf("HK") == -1 &&
          value.indexOf("CN") == -1 &&
          value.indexOf("DB") == -1 &&
          value.indexOf("TW") == -1
        ) {
          callback(
            new Error(
              "Please select at least 1 region under Hong Kong sales office"
            )
          );
        }
        if (
          value.indexOf("ID") == -1 &&
          value.indexOf("SG") == -1 &&
          value.indexOf("JP") == -1 &&
          value.indexOf("MY") == -1
        ) {
          callback(
            new Error(
              "Please select at least 1 region under Singapore sales office"
            )
          );
        }
        callback();
      } else {
        callback();
      }
    };
    return {
      formNotificationRules: this.$validation.pushCreate(regionValidator),
      formNotification: {
        important: false,
        salesOffice: [],
        region: [],
        notificationType: "",
        titleEn: "",
        titleJp: "",
        titleTc: "",
        titleSc: "",
        summaryEn: "",
        summaryJp: "",
        summaryTc: "",
        summarySc: "",
        deliveryDate: "",
        deliveryD: "",
        deliveryT: "",
        imageEn: "",
        imageJp: "",
        imageTc: "",
        imageSc: "",
        imageIsSame4All: false,
        button1Type: "NONE",
        // button1IdName:"",
        button1IdNameHK: "",
        button1IdNameSG: "",
        button1NameEn: "",
        button1NameJp: "",
        button1NameTc: "",
        button1NameSc: "",
        button1URLEn: "",
        button1URLJp: "",
        button1URLTc: "",
        button1URLSc: "",
        button2Type: "NONE",
        // button2IdName:"",
        button2IdNameHK: "",
        button2IdNameSG: "",
        button2NameEn: "",
        button2NameJp: "",
        button2NameTc: "",
        button2NameSc: "",
        button2URLEn: "",
        button2URLJp: "",
        button2URLTc: "",
        button2URLSc: "",
        csvFile: "",
        notificationCategory: "",
        csvType: "ID_ONLY",
      },
      salesOfficeList: [],
      regionList: [],
      imageEnFileParams: { action: "/upload/blob/INBOX_IMAGE" },
      imageEnFileList: [],
      imageJpFileParams: { action: "/upload/blob/INBOX_IMAGE" },
      imageJpFileList: [],
      imageTcFileParams: { action: "/upload/blob/INBOX_IMAGE" },
      imageTcFileList: [],
      imageScFileParams: { action: "/upload/blob/INBOX_IMAGE" },
      imageScFileList: [],
      projectListHK: [],
      projectListSG: [],
      CSVFileParams: { action: "/upload/blob/INBOX_CLIENT" },

      CSVFileList: [],
      viewDialog: false,
      tableData: [],
      total: 0,
      currentSize: 10,
      currentPage: 1,
      clientFilter: "0",
      clientTotal: 0,
      csvIgnoreTotal: 0,
      hkTotal: 0,
      sgTotal: 0,
      formFilter: {
        salesOffice: "",
        region: "",
        userStatus: "",
        inboxStatus: "",
        pushStatus: "",
        clientId: "",
      },
      tagDialog: false,
      // csvDialog:false
      CSV_FILE_TYPE: {
        ID_ONLY: "ID_ONLY",
        CLIENT_PARAM: "CLIENT_PARAM",
        PARTNER_PARAM: "PARTNER_PARAM",
      },
      showSave: true,
    };
  },
  components: {
    "upload-image": UploadImage,
  },
  computed: {
    csvHasVariables() {
      return (
        this.formNotification.csvType === this.CSV_FILE_TYPE.CLIENT_PARAM ||
        this.formNotification.csvType === this.CSV_FILE_TYPE.PARTNER_PARAM
      );
    },
  },
  methods: {
    getProjectList() {
      let paramsHK = {
        unPaged: true,
        salesOffice: "HK",
      };
      let paramsSG = {
        unPaged: true,
        salesOffice: "SG",
      };
      projectList(paramsHK).then((res) => {
        this.projectListHK = res.data.content;
      });
      projectList(paramsSG).then((res) => {
        this.projectListSG = res.data.content;
      });
    },
    getOffice() {
      getSalesOffice().then((res) => {
        this.salesOfficeList = res.data.payload;
        if (this.$store.state.userLevel >= 2) {
          let salesOffice = this.$store.state.salesOffices;
          this.formNotification.salesOffice = salesOffice;
          this.changeSalesOffice(this.formNotification.salesOffice);
        }
      });
    },
    changeSalesOffice(v) {
      this.clearRegion();
      if (v.length > 1 || !v.length) {
        getSalesRegion("").then((res) => {
          this.regionList = res.data.payload;
          if (this.formNotification.notificationType !== "SYSTEM") {
            res.data.payload.forEach((item) => {
              this.formNotification.region.push(item.code);
            });
          }
          console.log(this.formNotification.region);
        });
      } else {
        getSalesRegion(v).then((res) => {
          this.regionList = res.data.payload;
          if (this.formNotification.notificationType !== "SYSTEM") {
            res.data.payload.forEach((item) => {
              this.formNotification.region.push(item.code);
            });
          }
          console.log(this.formNotification.region);
        });
      }
    },
    clearRegion() {
      this.regionList = [];
      this.$set(this.formNotification, "region", []);
    },
    handleCancel() {
      this.$router.push("/pushNotification");
    },
    handleCreate() {
      console.log(this.formNotification);
      this.$refs.formNotification.validate((valid) => {
        if (valid) {
          let params = {
            type: this.formNotification.notificationType,
            deliveryDate: this.formNotification.deliveryDate,
            titles: {
              EN: this.formNotification.titleEn,
              JA: this.formNotification.titleJp,
              ZH_HK: this.formNotification.titleTc,
              ZH_CN: this.formNotification.titleSc,
            },
            summary: {
              EN: this.formNotification.summaryEn,
              JA: this.formNotification.summaryJp,
              ZH_HK: this.formNotification.summaryTc,
              ZH_CN: this.formNotification.summarySc,
            },
            contents: {
              EN: this.formNotification.contentEn,
              JA: this.formNotification.contentJp,
              ZH_HK: this.formNotification.contentTc,
              ZH_CN: this.formNotification.contentSc,
            },
            imageIsSame4All: this.formNotification.imageIsSame4All,
            button1Type: this.formNotification.button1Type,
            button2Type: this.formNotification.button2Type,
            category: this.formNotification.notificationCategory,
            salesOffices: this.formNotification.salesOffice,
            regions: this.formNotification.region,
            important: this.formNotification.important,
          };
          if (this.formNotification.notificationType !== "SYSTEM")
            params["hasVariables"] = this.csvHasVariables;
          if (this.formNotification.notificationType !== "SYSTEM")
            params["csvFileId"] = this.formNotification.csvFile;
          if (this.formNotification.notificationType !== "SYSTEM")
            params["csvType"] = this.formNotification.csvType;

          if (
            this.formNotification.imageEn ||
            this.formNotification.imageJp ||
            this.formNotification.imageTc ||
            this.formNotification.imageSc
          ) {
            params["imageIds"] = {};
            if (this.formNotification.imageIsSame4All) {
              params["imageIds"]["EN"] = this.formNotification.imageEn;
            } else {
              if (this.formNotification.imageEn)
                params["imageIds"]["EN"] = this.formNotification.imageEn;
              if (this.formNotification.imageJp)
                params["imageIds"]["JA"] = this.formNotification.imageJp;
              if (this.formNotification.imageTc)
                params["imageIds"]["ZH_HK"] = this.formNotification.imageTc;
              if (this.formNotification.imageSc)
                params["imageIds"]["ZH_CN"] = this.formNotification.imageSc;
            }
          }
          if (this.formNotification.button1Type == "URL") {
            params["button1Names"] = {};
            params["button1Urls"] = {};
            params["button1Names"]["EN"] = this.formNotification.button1NameEn;
            params["button1Names"]["JA"] = this.formNotification.button1NameJp;
            params["button1Names"]["ZH_HK"] =
              this.formNotification.button1NameTc;
            params["button1Names"]["ZH_CN"] =
              this.formNotification.button1NameSc;
            params["button1Urls"]["EN"] = this.formNotification.button1URLEn;
            params["button1Urls"]["JA"] = this.formNotification.button1URLJp;
            params["button1Urls"]["ZH_HK"] = this.formNotification.button1URLTc;
            params["button1Urls"]["ZH_CN"] = this.formNotification.button1URLSc;
          }
          if (this.formNotification.button2Type == "URL") {
            params["button2Names"] = {};
            params["button2Urls"] = {};
            params["button2Names"]["EN"] = this.formNotification.button2NameEn;
            params["button2Names"]["JA"] = this.formNotification.button2NameJp;
            params["button2Names"]["ZH_HK"] =
              this.formNotification.button2NameTc;
            params["button2Names"]["ZH_CN"] =
              this.formNotification.button2NameSc;
            params["button2Urls"]["EN"] = this.formNotification.button2URLEn;
            params["button2Urls"]["JA"] = this.formNotification.button2URLJp;
            params["button2Urls"]["ZH_HK"] = this.formNotification.button2URLTc;
            params["button2Urls"]["ZH_CN"] = this.formNotification.button2URLSc;
          }
          if (this.formNotification.button1Type == "PROJECT") {
            params["button1Names"] = {};
            if (this.formNotification.salesOffice.indexOf("HK") !== -1)
              params["button1ProjectIdHk"] =
                this.formNotification.button1IdNameHK;
            if (this.formNotification.salesOffice.indexOf("SG") !== -1)
              params["button1ProjectIdSg"] =
                this.formNotification.button1IdNameSG;
            params["button1Names"]["EN"] = this.formNotification.button1NameEn;
            params["button1Names"]["JA"] = this.formNotification.button1NameJp;
            params["button1Names"]["ZH_HK"] =
              this.formNotification.button1NameTc;
            params["button1Names"]["ZH_CN"] =
              this.formNotification.button1NameSc;
          }
          if (this.formNotification.button2Type == "PROJECT") {
            params["button2Names"] = {};
            if (this.formNotification.salesOffice.indexOf("HK") !== -1)
              params["button2ProjectIdHk"] =
                this.formNotification.button2IdNameHK;
            if (this.formNotification.salesOffice.indexOf("SG") !== -1)
              params["button2ProjectIdSg"] =
                this.formNotification.button2IdNameSG;
            params["button2Names"]["EN"] = this.formNotification.button2NameEn;
            params["button2Names"]["JA"] = this.formNotification.button2NameJp;
            params["button2Names"]["ZH_HK"] =
              this.formNotification.button2NameTc;
            params["button2Names"]["ZH_CN"] =
              this.formNotification.button2NameSc;
          }
          if (this.formNotification.button1Type == "INVESTMENT") {
            params["button1Names"] = {};
            params["button1Names"]["EN"] = this.formNotification.button1NameEn;
            params["button1Names"]["JA"] = this.formNotification.button1NameJp;
            params["button1Names"]["ZH_HK"] =
              this.formNotification.button1NameTc;
            params["button1Names"]["ZH_CN"] =
              this.formNotification.button1NameSc;
          }
          if (this.formNotification.button2Type == "INVESTMENT") {
            params["button2Names"] = {};
            params["button2Names"]["EN"] = this.formNotification.button2NameEn;
            params["button2Names"]["JA"] = this.formNotification.button2NameJp;
            params["button2Names"]["ZH_HK"] =
              this.formNotification.button2NameTc;
            params["button2Names"]["ZH_CN"] =
              this.formNotification.button2NameSc;
          }
          console.log(params);
          notificationAdd(params).then((res) => {
            console.log(res);
            if (res.data.status == "00") {
              this.$message.success("Push Notification is created");
              this.handleCancel();
            } else {
              this.$message.error(res.data.msg);
            }
          });
        }
      });
    },
    validContent(name, id) {
      this.$refs.formNotification.validateField(name);
      if (id) {
        let e = document.querySelector(`#${id} .ql-tooltip,#${id} .ql-editing`);
        if (e) {
          let left = e.style.left;
          if (left.indexOf("-") === 0) {
            e.style.left = 0;
          }
        }
      }
    },
    getImageEnRes(res) {
      console.log("ImageEn file list===", res);
      this.formNotification.imageEn = "";
      res.forEach((item) => {
        if (item.response) {
          this.formNotification.imageEn = item.response.payload.fileId;
        } else if (item.fileId) {
          this.formNotification.imageEn = item.fileId;
        } else {
          this.formNotification.imageEn = "null";
        }
      });
      console.log(
        "this.formNotification.imageEn ===",
        this.formNotification.imageEn
      );
    },
    getImageJpRes(res) {
      console.log("ImageJp file list===", res);
      this.formNotification.imageJp = "";
      res.forEach((item) => {
        if (item.response) {
          this.formNotification.imageJp = item.response.payload.fileId;
        } else if (item.fileId) {
          this.formNotification.imageJp = item.fileId;
        } else {
          this.formNotification.imageJp = "null";
        }
      });
      console.log(
        "this.formNotification.imageJp ===",
        this.formNotification.imageJp
      );
    },
    getImageTcRes(res) {
      console.log("ImageTc file list===", res);
      this.formNotification.imageTc = "";
      res.forEach((item) => {
        if (item.response) {
          this.formNotification.imageTc = item.response.payload.fileId;
        } else if (item.fileId) {
          this.formNotification.imageTc = item.fileId;
        } else {
          this.formNotification.imageTc = "null";
        }
      });
      console.log(
        "this.formNotification.imageTc ===",
        this.formNotification.imageTc
      );
    },
    getImageScRes(res) {
      console.log("ImageSc file list===", res);
      this.formNotification.imageSc = "";
      res.forEach((item) => {
        if (item.response) {
          this.formNotification.imageSc = item.response.payload.fileId;
        } else if (item.fileId) {
          this.formNotification.imageSc = item.fileId;
        } else {
          this.formNotification.imageSc = "null";
        }
      });
      console.log(
        "this.formNotification.imageSc ===",
        this.formNotification.imageSc
      );
    },
    handleButtonChecking(v, buttonNo) {
      if (buttonNo == "1" && v == "NONE") {
        this.formNotification.button2Type = "NONE";
      }
      if (v == "NONE")
        this.$refs.formNotification.clearValidate([
          "button" + buttonNo + "IdName",
          "button" + buttonNo + "NameEn",
          "button" + buttonNo + "NameJp",
          "button" + buttonNo + "NameTc",
          "button" + buttonNo + "NameSc",
          "button" + buttonNo + "URLEn",
          "button" + buttonNo + "URLJp",
          "button" + buttonNo + "URLTc",
          "button" + buttonNo + "URLSc",
        ]);
      if (v == "URL")
        this.$refs.formNotification.clearValidate([
          "button" + buttonNo + "IdName",
        ]);
      if (v == "PROJECT")
        this.$refs.formNotification.clearValidate([
          "button" + buttonNo + "URLEn",
          "button" + buttonNo + "URLJp",
          "button" + buttonNo + "URLTc",
          "button" + buttonNo + "URLSc",
        ]);
    },
    disabledDate(v) {
      if (new Date(v).getTime() < new Date().getTime()) {
        return true;
      }
      return false;
    },
    getCSVRes(res) {
      console.log("csv file list===", res);
      this.formNotification.csvFile = "";
      res.forEach((item) => {
        if (item.response) {
          this.formNotification.csvFile = item.response.payload.fileId;
        } else if (item.fileId) {
          this.formNotification.csvFile = item.fileId;
        } else {
          this.formNotification.csvFile = "null";
        }
      });
      this.$refs.formNotification.clearValidate("csvFile");
      console.log(
        "this.formNotification.thumbnail ===",
        this.formNotification.csvFile
      );
    },
    handleView() {
      if (this.formNotification.csvFile) {
        if (this.$refs.formFilter) this.$refs.formFilter.resetFields();
        this.getClientList(() => {
          this.viewDialog = true;
        });
      } else {
        this.$message.error(
          "Please upload csv file before you view client list"
        );
      }
    },
    getClientList(callback) {
      let params = {
        page: this.currentPage - 1,
        size: this.currentSize,
        fileId: this.formNotification.csvFile,
      };
      if (this.formFilter.clientId)
        params["clientId"] = this.formFilter.clientId;
      if (this.formFilter.salesOffice)
        params["salesOffice"] = this.formFilter.salesOffice;
      if (this.formFilter.region) params["regions"] = this.formFilter.region;
      if (this.formFilter.userStatus)
        params["userStatus"] = this.formFilter.userStatus;
      if (this.formFilter.inboxStatus)
        params["inboxStatus"] = this.formFilter.inboxStatus;
      if (this.formFilter.pushStatus)
        params["pushStatus"] = this.formFilter.pushStatus;
      notificationClientList(params).then((res) => {
        if (res.data.status == "00") {
          this.tableData = res.data.payload.clientList.content;
          this.total = res.data.payload.clientList.totalElements;
          this.csvIgnoreTotal = res.data.payload.csvIgnoreTotal;
          this.clientTotal = res.data.payload.clientTotal;
          this.sgTotal = res.data.payload.salesOfficesTotal.SG;
          this.hkTotal = res.data.payload.salesOfficesTotal.HK;
          if (callback) callback();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    handleDeliveryDate() {
      if (this.formNotification.deliveryD && this.formNotification.deliveryT) {
        this.formNotification.deliveryDate =
          this.formNotification.deliveryD +
          " " +
          this.formNotification.deliveryT;
        this.$refs.formNotification.validateField(["deliveryDate"]);
      } else {
        this.formNotification.deliveryDate = "";
        this.$refs.formNotification.validateField(["deliveryDate"]);
      }
    },
    handleTypeChange(v) {
      if (v == "SYSTEM") {
        this.$refs.formNotification.clearValidate(["csvFile"]);
        this.changeSalesOffice(this.formNotification.salesOffice);
      } else {
        this.$refs.formNotification.clearValidate(["salesOffice", "region"]);
        this.changeSalesOffice(this.formNotification.salesOffice);
      }
    },
    refreshClientList() {
      notificationClientListDelete(this.formNotification.csvFile).then(
        (res) => {
          if (res.data.status == "00") {
            let params = {
              page: this.currentPage,
              size: this.currentSize,
              fileId: this.formNotification.csvFile,
            };
            if (this.clientFilter == "1") params["isInvalidUser"] = true;
            if (this.clientFilter == "2") params["salesOffice"] = "HK";
            if (this.clientFilter == "3") params["salesOffice"] = "SG";
            notificationClientList(params).then((result) => {
              if (res.data.status == "00") {
                this.tableData = res.data.payload.clientList.content;
                this.total = res.data.payload.clientList.totalElements;
                this.csvIgnoreTotal = res.data.payload.csvIgnoreTotal;
                this.clientTotal = res.data.payload.clientTotal;
                this.sgTotal = res.data.payload.salesOfficesTotal.SG;
                this.hkTotal = res.data.payload.salesOfficesTotal.HK;
              } else {
                this.$message.error(result.data.msg);
              }
            });
          } else {
            this.$message.error(res.data.msg);
          }
        }
      );
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.getClientList();
    },
    submitApply() {
      this.currentPage = 1;
      this.getClientList();
    },
    handleDownloadTemplate() {
      window.open(
        "https://my.walton.com/walton-web-prod/system/App_Push_Notification_Template.csv",
        "_blank"
      );
    },
    showBtn(val) {
      console.log(this.$store.state.permissions);
      var permissions = this.$store.state.permissions.filter(
        (item) => item == val
      );
      if (!permissions[0]) {
        this.showSave = false;
      }
    },
  },
  created: function () {
    this.getOffice();
    getSalesRegion("").then((res) => {
      this.regionList = res.data.payload;
    });
    this.getProjectList();
    this.showBtn("CAMPAIGN_WRITE");
  },
};
</script>

<style scoped>
@import "../../styles/editor.css";
.el-row {
  margin-bottom: 20px;
}
.el-row:last-child {
  margin-bottom: 0;
}
.ql-editor {
  margin-left: -15px;
}
.clientListFilter {
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>




// WEBPACK FOOTER //
// src/components/notification/createNotification.vue